import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { WEBINAR_EVENTS } from '../data/webinarEvents';
import '../components/ElearningEnrollmentModal.css';
import './WebinarsEventsModal.css';

function WebinarsEventsModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div
      className="elearning-enrollment-overlay webinars-events-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="webinars-events-modal-title"
      onClick={onClose}
    >
      <div
        className="elearning-enrollment-modal webinars-events-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="webinars-events-modal-header">
          <div>
            <span className="webinars-events-modal-chip">Upcoming</span>
            <h2 id="webinars-events-modal-title" className="webinars-events-modal-title">
              Webinars & Events
            </h2>
            <p className="webinars-events-modal-lead">
              Join Lotus STEMM and Campfire Kinship for live workshops aligned with the Assume We Can learning series.
            </p>
          </div>
          <button
            type="button"
            className="elearning-enrollment-modal-close"
            aria-label="Close"
            onClick={onClose}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <ul className="webinars-events-list">
          {WEBINAR_EVENTS.map((event) => (
            <li key={event.id}>
              <article className="webinars-events-card">
                <div className="webinars-events-card-meta">
                  <span className="webinars-events-format">{event.format}</span>
                  {event.duration ? (
                    <span className="webinars-events-duration">{event.duration}</span>
                  ) : null}
                </div>
                <h3 className="webinars-events-card-title">{event.title}</h3>
                {event.schedule ? (
                  <p className="webinars-events-schedule">{event.schedule}</p>
                ) : null}
                <p className="webinars-events-card-desc">{event.description}</p>
                {event.organizer ? (
                  <p className="webinars-events-organizer">Hosted by {event.organizer}</p>
                ) : null}
                <a
                  href={event.href}
                  className="webinars-events-register-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Register on Eventbrite
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </article>
            </li>
          ))}
        </ul>
      </div>
    </div>,
    document.body
  );
}

export default WebinarsEventsModal;
